import axios from 'axios';
import dayjs from 'dayjs';

export const FALLBACK_COLOR = '#0969da';

// Fetch tasks assigned to the logged-in user that touch [start, end] (inclusive dates).
// `filters` are the Overview filter-bar values (project, priority, …).
export const fetchMySchedule = async (start, end, filters = {}) => {
  const res = await axios.get('/project_board/dashboard/my_calendar/', {
    params: { ...filters, start: dayjs(start).format('YYYY-MM-DD'), end: dayjs(end).format('YYYY-MM-DD') },
  });
  return res.data || { tasks: [], undated_count: 0 };
};

// Planned range of a task as [start, end] dayjs (inclusive), or null when it has none.
// A range with only one side set is treated as a single day.
export const plannedRange = (t) => {
  const s = t.estimated_start_date || t.estimated_end_date;
  const e = t.estimated_end_date || t.estimated_start_date;
  if (!s) return null;
  const a = dayjs(s);
  const b = dayjs(e);
  return a.isAfter(b) ? [b, a] : [a, b];
};

const isHex = (c) => /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(c || '');

export const statusColor = (t) => (isHex(t.status_color) ? t.status_color : FALLBACK_COLOR);

// Black or white text, whichever reads better on the given hex background.
export const textOn = (hex) => {
  let h = (hex || '').replace('#', '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  const n = parseInt(h, 16);
  if (Number.isNaN(n)) return '#fff';
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? '#1f2328' : '#fff';
};

export const taskLabel = (t) => (t.task_code ? `${t.task_code} · ${t.title}` : t.title);
